export const dentalPageSections = [
  { id: "dental-overview", label: "Overview", shortLabel: "Overview" },
  { id: "front-desk-story", label: "Benefits for Your Team", shortLabel: "Benefits" },
  { id: "dental-practice-impact", label: "Practices in days", shortLabel: "Practices" },
  { id: "conversation-dashboard", label: "Conversations in One Place", shortLabel: "Conversations" },
  { id: "dental-integrations", label: "Integrations & Workflows", shortLabel: "Integrations" },
  { id: "dental-pms-setup", label: "Setup in One Conversation", shortLabel: "Setup" },
  { id: "workflow-console", label: "Demo: Booking in Action", shortLabel: "Demo" },
  { id: "pricing", label: "Pricing & Plans", shortLabel: "Pricing" },
  { id: "dental-faq", label: "FAQs & Contact", shortLabel: "FAQs" },
] as const;

type PageSectionBounds = { top: number; bottom: number };

export function getDentalPageProgress(
  sections: readonly PageSectionBounds[], scrollTop: number, viewportHeight: number, documentHeight: number,
) {
  if (!sections.length) return { activeIndex: -1, percent: 0, sectionPercent: 0 };
  const maxScroll = Math.max(0, documentHeight - viewportHeight);
  const position = Math.max(0, Math.min(scrollTop, maxScroll));
  const percent = maxScroll > 0 ? Math.round(position / maxScroll * 100) : 100;
  if (position <= 1) return { activeIndex: 0, percent, sectionPercent: maxScroll > 0 ? 0 : 100 };
  if (position >= maxScroll - 1) return { activeIndex: sections.length - 1, percent, sectionPercent: 100 };

  // Follow the section being read in the middle of the viewport. Measuring
  // real section bounds also covers long pricing panels and expanding FAQs.
  const readingLine = position + viewportHeight / 2;
  let activeIndex = 0;
  for (let index = 0; index < sections.length; index += 1) {
    if (sections[index].top > readingLine) break;
    activeIndex = index;
  }
  const current = sections[activeIndex];
  const sectionPercent = Math.round(Math.max(0, Math.min(1, (readingLine - current.top) / Math.max(1, current.bottom - current.top))) * 100);
  return { activeIndex, percent, sectionPercent };
}
